import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";
import Search from "../pages/search/page";
import SiteLayout from "../components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "news", element: <News /> },
      { path: "news/detail/:id", element: <NewsDetail /> },
      { path: "search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;